import { render } from "./IconPicker.vue?vue&type=template&id=0835c117&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=js"
export * from "./IconPicker.vue?vue&type=script&lang=js"

import "./IconPicker.vue?vue&type=style&index=0&id=0835c117&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0835c117"],['__file',"src/components/IconPicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0835c117"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0835c117', __exports__)) {
    api.reload('0835c117', __exports__)
  }
  
  module.hot.accept("./IconPicker.vue?vue&type=template&id=0835c117&scoped=true", () => {
    api.rerender('0835c117', render)
  })

}


export default __exports__